import { atom } from 'jotai';

import { selectedProductsCountState } from './row-selection.state';

/**
 * State that determines if the floating action menu should be shown.
 * The menu appears when one or more products are selected.
 */
export const shouldShowFloatingActionMenuState = atom((get) => {
  const selectedCount = get(selectedProductsCountState);
  return selectedCount >= 1;
});
